
import * as __star__ from 'react-dnd-html5-backend';

const {

getEmptyImage,
HTML5Backend,
NativeTypes,
__esModule
} = __star__;

export {
getEmptyImage,
HTML5Backend,
NativeTypes,
__esModule
};

